/** Static class name map — avoids CSS module bundling issues with tsup */
export const styles = {
  spinnerSpin: 'gooey-spinnerSpin',
  wrapper: 'gooey-wrapper',
  blobSvg: 'gooey-blobSvg',
  content: 'gooey-content',
  contentCompact: 'gooey-contentCompact',
  contentExpanded: 'gooey-contentExpanded',
  header: 'gooey-header',
  iconWrapper: 'gooey-iconWrapper',
  title: 'gooey-title',
  titleDefault: 'gooey-titleDefault',
  titleSuccess: 'gooey-titleSuccess',
  titleError: 'gooey-titleError',
  titleWarning: 'gooey-titleWarning',
  titleInfo: 'gooey-titleInfo',
  titleLoading: 'gooey-titleLoading',
  description: 'gooey-description',
  actionWrapper: 'gooey-actionWrapper',
  actionButton: 'gooey-actionButton',
  actionDefault: 'gooey-actionDefault',
  actionSuccess: 'gooey-actionSuccess',
  actionError: 'gooey-actionError',
  actionWarning: 'gooey-actionWarning',
  actionInfo: 'gooey-actionInfo',
  progressWrapper: 'gooey-progressWrapper',
  progressBar: 'gooey-progressBar',
  progressDefault: 'gooey-progressDefault',
  progressSuccess: 'gooey-progressSuccess',
  progressError: 'gooey-progressError',
  progressWarning: 'gooey-progressWarning',
  progressInfo: 'gooey-progressInfo',
  progressPaused: 'gooey-progressPaused',
  timestamp: 'gooey-timestamp',
  closeButton: 'gooey-closeButton',
  closeButtonRight: 'gooey-closeButtonRight',
} as const
